// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

import type {
	CoolReport,
	EventHistory,
	HistoryEntry,
} from "@dsbunny/rmm-schema";

export class Cool {
	protected _is_online: boolean = false;
	protected _accumulated_failure_count: number = 1;
	protected _accumulated_outage_time: number = 0;
	protected _recording_start_time: string;
	protected _transition_time: Date;
	protected _eventHistory: EventHistory = {
		history_size: 0,
		history_msgs_flushed: 0,
		history: [],
	};
	protected _event_id: number = 0;

	constructor(
		recording_start_time: Date,
		history_size: number = 10,
	) {
		this._recording_start_time = recording_start_time.toISOString();
		this._transition_time = new Date(recording_start_time);
		this._eventHistory.history_size = history_size;
	}

	online(now = new Date()): void {
		if(this._is_online) {
			return; // Already online, no action needed.
		}
		const event: HistoryEntry = {
			index: this._event_id++,
			status: 'UP',
			time: now.toISOString(),
			interval: (now.getTime() - this._transition_time.getTime()) / 1000, // Convert to seconds
		};
		this._eventHistory.history.push(event);
		if(this._eventHistory.history.length > this._eventHistory.history_size) {
			this._eventHistory.history.shift();
			this._eventHistory.history_msgs_flushed++;
		}
		this._is_online = true;
		this._accumulated_failure_count++;
		this._accumulated_outage_time += event.interval;
		this._transition_time = now;
	}

	outage(now = new Date()): void {
		if(!this._is_online) {
			return; // Already in outage, no action needed.
		}
		const event: HistoryEntry = {
			index: this._event_id++,
			status: 'DOWN',
			time: now.toISOString(),
			interval: (now.getTime() - this._transition_time.getTime()) / 1000, // Convert to seconds
		};
		this._eventHistory.history.push(event);
		if(this._eventHistory.history.length > this._eventHistory.history_size) {
			this._eventHistory.history.shift();
			this._eventHistory.history_msgs_flushed++;
		}
		this._is_online = false;
		this._transition_time = now;
	}

	report(): CoolReport | null {
		return {
			eventHistory: this._eventHistory,
			objectOutage: {
				status: this._is_online ? 'UP' : 'DOWN',
				time: this._recording_start_time,
				aot: this._accumulated_outage_time,
				naf: this._accumulated_failure_count,
			}
		};
	}
}
